import { createFileRoute } from '@tanstack/react-router';

import { SourcingTemplateCreatePage } from '@/areas/sourcing-scenarios/SourcingTemplates/SourcingTemplateCreatePage';
import { canManageSourcingTemplates } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/templates/_sidebar/sourcing/create')({
    staticData: { access: { permissions: canManageSourcingTemplates }, chrome: 'home' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <SourcingTemplateCreatePage />;
}
